<template>
	<div class="width_100">
		<naviBack type='list1' title="创建预约单" background="#ffffff" />
		
		<div class="cmbc_createorder width_100 bg_FFFFFF">
			<div class="cmbc_createorder1 width_100 color_333333 font_size_40 font_weight_600">单次游泳</div>
			<div class="cmbc_createorder2 width_100 font_size_30">北京爱尚健身馆（冠城店）</div>
		</div>
		
		<div class="cmbc_co_body width_100 border_radius_16">
			<div class="cmbc_co_body_item cmbc_co_body_item_mag width_100 bg_FFFFFF border_radius_16">
				<div class="cmbc_co_body_item_title width_100 font_size_30 color_333333 font_weight_600 display_start_center">
					羽毛球
					<div class="font_size_26 color_F77F28">1月4日  周日</div>
				</div>
				<div class="cmbc_co_body_item_list width_100">
					<div class="width_fit display_start_center text_ellipsis2">
						<div v-for="(item_co,index_co) in 3" :key="'item_co'+index_co" 
						class="cmbc_co_body_item_list_item border_radius_8 display_center_center text_align_center">
							<div>
								<div class="color_666666 font_size_20">1号场地</div>
								<div class="color_333333 font_size_22">07:00-08:00</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="cmbc_co_body_item width_100 bg_FFFFFF border_radius_16">
				<div class="cmbc_co_body_item_title width_100 font_size_30 color_333333 font_weight_600">预约信息</div>
				<div
					class="cmbc_co_body_item_block width_100 display_between_center font_size_28 color_666666 text_ellipsis2">
					预约人
					<input v-model="user_info.name" class="color_333333" type="text" maxlength="48" />
				</div>
				<div
					class="cmbc_co_body_item_block width_100 display_between_center font_size_28 color_666666 text_ellipsis2">
					手机号
					<input v-model="user_info.phone" class="color_333333" type="tel" maxlength="11" />
				</div>
			</div>
			<div class="cmbc_co_body_tips width_100 color_F77F28">
				<div class="font_size_26">温馨提示：</div>
				<div class="font_size_26"
					v-html="'1、请按您所预订的人次下场使用，若超出预订人次，超出的成人或儿童需另外支付费用，具体收费标准以酒店健身中心规定为准。<br />2、请务必填写下场人和同行人（若有）真实姓名，以便入场时验证。如需取消订单请提前24小时。'">
				</div>
			</div>
		</div>

		<div class="cmbc_co_bottom width_100 bg_FFFFFF">
			<div class="width_100 display_center_center color_ffffff font_size_32">提交订单</div>
		</div>
	</div>
</template>

<script>
	import naviBack from '../components/navi_back.vue';
	export default {
		components: {
			naviBack,
		},
		name: "",
		data() {
			return {
				user_info: {
					name: '张三',
					phone: '1836528403'
				},
				max_guest:4,
				guest_arr: []
			};
		},
		mounted() {

		},
		methods: {
			addGuest() {
				if (this.max_guest == 0) {
					this.$toast({
					  message: '不可携带嘉宾',
					  forbidClick: true,
					});

					return
				}
				if (this.guest_arr.length == this.max_guest) {
					this.$toast({
					  message: '最多可携带' + this.max_guest + '名嘉宾',
					  forbidClick: true,
					});
					return
				}
				this.guest_arr=[...this.guest_arr,...['']]
			},
			deleteGuest(e) {
				var guest_arr = this.guest_arr
				guest_arr.splice(e, 1)
				this.guest_arr=guest_arr
			},
		},
	};
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750 * 100vw;
	.cmbc_createorder {
		padding: 40*@vm_base 40*@vm_base 60*@vm_base 40*@vm_base;

		.cmbc_createorder1 {
			line-height: 1.3;
		}

		.cmbc_createorder2 {
			color: #F77F28;
			line-height: 1.3;
			margin-top: 12*@vm_base;
		}
	}

	.cmbc_co_body {
		background: #F6F7F9;
		position: relative;
		margin-top: -20*@vm_base;
		padding: 20*@vm_base;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2 + 160*@vm_base);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 160*@vm_base);
		.cmbc_co_body_item {
			padding: 30*@vm_base 30*@vm_base 20*@vm_base 30*@vm_base;
			.cmbc_co_body_item_title {
				padding-bottom: 10*@vm_base;
				line-height: calc(4 / 3);
				div{
					margin-left: 20*@vm_base;
				}
			}
			.cmbc_co_body_item_block {
				margin-top: 6*@vm_base;

				div {
					line-height: calc(48 / 28);
					background-image: url(../resource/more_333333.png);
					background-repeat: no-repeat;
					background-position: right center;
					background-size: 30*@vm_base;
					padding-right: 32*@vm_base;
				}

				input {
					max-width: 80%;
					min-width: 50%;
					height: 48*@vm_base;
					text-align: right;
					border: none;
					background-image: url(../resource/more_333333.png);
					background-repeat: no-repeat;
					background-position: right center;
					background-size: 30*@vm_base;
					padding-right: 32*@vm_base;
				}
			}
			.cmbc_co_body_item_list{
				margin-top: 20*@vm_base;
				overflow: hidden;
				overflow-x: auto;
				padding-bottom: 10*@vm_base;
				&::-webkit-scrollbar{
					width: 0;height: 0;
				}
				.cmbc_co_body_item_list_item{
					width: 180*@vm_base;
					height: 92*@vm_base;
					background: #F6F7F9;
					margin-right: 20*@vm_base;
					&:last-child{
						margin-right: 0;
					}
					div{
						div{
							line-height: calc(3 / 2);
						}
					}
				}
			}
		}
		.cmbc_co_body_item_mag{
			margin-bottom: 20*@vm_base;
		}

		.cmbc_co_body_tips {
			padding: 80*@vm_base 30*@vm_base;

			div {
				line-height: calc(39 / 26);
			}
		}
	}
	.cmbc_co_bottom {
		position: fixed;
		bottom: 0;
		left: 0;
		padding: 25*@vm_base 75*@vm_base;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2 + 25*@vm_base);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 25*@vm_base);
		box-shadow: -4*@vm_base -4*@vm_base 6*@vm_base rgba(243, 207, 166, 0.5);
		border-radius: 16*@vm_base 16*@vm_base 0 0;

		div {
			height: 80*@vm_base;
			background: linear-gradient(233deg, #FB8027 0%, #FFA663 100%);
			border-radius: 40*@vm_base;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/create_order_2.vue